import Vue from 'vue';

import * as CourseManagement from '@/modules/CourseManagement/constants';
import * as Schedule from '@/modules/Education/Schedule/constants';
import * as CourseModules from '@/modules/Modules/constants';
import * as PaymentSystem from '@/modules/PaymentSystem/constants';
import { ROLES } from '@/modules/Auth/constants';
import Constants from '@/utils/constants';

const ConstantsPlugin = {
  install(V) {
    const constants = {
      ...Constants,
      ...CourseManagement,
      ...Schedule,
      ...CourseModules,
      ...PaymentSystem,
      ROLES,
    };
    const getConstantData = (constantName, id) => {
      const value = constants[`${constantName}`][id];
      const text = constants[`${constantName}_TEXT`][id];
      const color = constants[`${constantName}_COLORS`][id];
      return {
        text,
        value,
        color,
      };
    };

    const constantListProps = (constantName) => Object.values(constants[`${constantName}`])
      .reduce((acc, cur) => {
        acc.items.push({
          value: cur,
          text: constants[`${constantName}_TEXT`][cur],
        });
        return acc;
      }, { items: [], itemValue: 'value', itemText: 'text' });

    V.conf = { ...constants, getConstantData, constantListProps };
    V.prototype.$conf = { ...constants, getConstantData, constantListProps };
  },
};

Vue.use(ConstantsPlugin);
